var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 36,
    viewBox: "0 0 22 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 2H14.8C12.6783 2 10.6434 2.84285 9.14315 4.34315C7.64286 5.84344 6.8 7.87827 6.8 10V14.8H2V21.2H6.8V34H13.2V21.2H18L19.6 14.8H13.2V10C13.2 9.57565 13.3686 9.16869 13.6686 8.86863C13.9687 8.56857 14.3757 8.4 14.8 8.4H19.6V2Z",
    stroke: "#0EC99E",
    strokeWidth: 2.92114,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ed8a036ab94f67128e9ac60fbe3858fe.svg";
export { ForwardRef as ReactComponent };